import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, { Component } from 'react';
import Modal from 'react-modal';
import Alert from 'react-s-alert';
import firebase from 'firebase';

class ModalTarifasAvianca extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tarifa: this.props.tarifa || {},
            updating: this.props.updating || false,
            tiposVehiculo: [],
            valores: this.props.tarifa.valores || {}
        }
    }

    componentDidMount(){ this.getTiposVehiculo() }

    getTiposVehiculo(){
        firebase.database().ref('Tipos_Vehiculos').once('value').then(snap => {
            let tiposVehiculo = [];
            snap.forEach(element => {
                let e = element.val();
                tiposVehiculo.push({ ...e, key: element.key });
            });
            this.setState({ tiposVehiculo });
        })
    }

    componentDidUpdate(prevProps){
        if(prevProps.tarifa !== this.props.tarifa){
            this.setState({ tarifa: this.props.tarifa, valores: this.props.tarifa.valores, updating: this.props.updating });
        }
    }

    handleChange = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const name = e.target.name;
        this.setState({ tarifa: { ...this.state.tarifa, [name]: value }});
    }

    handleChangeChild = (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        const name = e.target.name;
        this.setState({ tarifa: { ...this.state.tarifa, valores: { ...this.state.tarifa.valores, [name]: value } }});
    }

    handleSubmit(e){
        e.preventDefault();
        this.state.updating ? this.updateTarifa() : this.pushTarifa();
        this.props.toggleModal();
    }

    updateTarifa(){ firebase.database().ref('TarifasAvianca').child(this.props.tarifa.key).update(this.state.tarifa) }

    pushTarifa(){ firebase.database().ref('TarifasAvianca').push(this.state.tarifa) }

    render() {
        let { tarifa, tiposVehiculo, valores } = this.state;
        return (
            <div className="modal-tarifas">
                <button className="btn btn-primary" onClick={this.props.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
                <Modal isOpen={this.props.isActive} style={customStyles}>
                    <h3>Agregar una nueva tarifa</h3>
                    <hr />
                    <form onSubmit={this.handleSubmit.bind(this)}>
                        <div className="form-group">
                            <label htmlFor="tipo">Nombre</label>
                            <input type="text" name="tipo" defaultValue={tarifa.tipo} required id="tipo" placeholder="Nombre" className="form-control" autoComplete="off" onChange={this.handleChange.bind(this)}/>
                        </div>
                        <div className="form-group">
                            <label htmlFor="origen">Origen</label>
                            <input onChange={this.handleChange.bind(this)} defaultValue={tarifa.origen} type="text" name="origen" placeholder="Origen" className="form-control" autoComplete="off" required />
                        </div>
                        <div className="form-group">
                            <label htmlFor="destino">Destino</label>
                            <input onChange={this.handleChange.bind(this)} defaultValue={tarifa.destino} type="text" name="destino" placeholder="Destino" className="form-control" autoComplete="off" required />
                        </div>
                        {
                            tiposVehiculo.map(s => {
                                return(
                                    <div className="form-group">
                                        <label htmlFor={s.tipo}>{s.tipo}</label>
                                        <input type="number" min="0.00" step="0.01" onChange={this.handleChangeChild.bind(this)} defaultValue={valores[s.tipo]} name={s.tipo} placeholder={s.tipo} className="form-control" autoComplete="off" required />
                                    </div>
                                );
                            })
                        }
                        <hr />
                        <button type="submit" className="btn btn-primary buttons">Guardar</button>
                    </form>
                    <button type="button" onClick={this.props.toggleModal} className="btn btn-default buttons  btnmargin">Cerrar</button>
                </Modal>
            </div>
        )
    }
}

export default ModalTarifasAvianca;

const customStyles = {
    content: {
        top: '60%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        width: '450px'
    }
}


// WEBPACK FOOTER //
// ./src/Components/Tarifas/ModalTarifasAvianca.js